import SelectSelect from './Select'

export default SelectSelect